export class ProfileAPI {
    static readonly SLASH_PROFILE = '/profile';
    static readonly SLASH_USER_ID = '/users';
    static readonly SLASH = '/';
    static readonly PROFILES_URL = '/profiles';
    static readonly PROFILE_NAME = '?profilename=';
    static readonly ASSET_ID_URL = '?asset-id=';
    static readonly SEARCH_QUERY = '?';
    static readonly USER_ID = 'userId';
    static readonly WINDOWS_QUERY_PARAM = 'win';
    static readonly WINDOWS_10S_QUERY_PARAM = 'uwp';
    static readonly WINDOWS = 'windows';
    static readonly LINUX_ISO_QUERY_PARAM = 'iso';
    static readonly LINUX_IPOS_QUERY_PARAM = 'deb';
    static readonly GET_PROFILES = 'getProfiles';
    static readonly PACKAGE = 'package';
    static readonly PACKAGE_TYPE = 'packagetype';
    static readonly OPERATING_SYSTEM = 'operatingsystem';
    static readonly ACTION = 'action';
    static readonly LINUX = 'Linux';
    static readonly EQUALS = '=';
    static readonly USERID = 'userid';
    static readonly CHROME_QUERY_PARAM = 'chrome';
    static readonly RETAILER_ID_ATTR_NAME = 'retailerId';
    static readonly RETAILER_ID = '?retailerId=';
    static readonly PACKAGE_STATUS = '?packageStatus=completed';
    static readonly RETAILERS_ID = '?retailer-id=';
    static readonly PACKAGE_HANDLER = '/packagehandler/package/standard/user-type/connected';
    static readonly PAGE_NO = '&pagenumber=';
    static readonly PUSH_PROFILE_QUERY = '?pushProfile=true';
    static readonly PUSH_PROFILE = '&pushProfile=true';
    static readonly PROFILE_SORT_ASC = '&sortby=profileName&sorttype=asc';
}
export class ProfileConstants {
    static readonly PROFILE_NAME_ALREADY_EXISTS = $localize`:@@duplicate-popup.duplicate-profile-name-validation-msg:Profile Name already exists`;
}